export default function CalendarDetails() {
    return (
      <div>
        <div className="water-bg bg-image">
<div className="gap-spacer"></div>
<div className="page-title top-cap-outlines">
    <h2>Calendar</h2>
</div>

<div className="content-fluid">
    <div className="mb-960-center-container mid-side-outlines">
        

            <iframe src="https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=America%2FNew_York&showPrint=0&showTz=0&mode=AGENDA&title=Morrisville%20Borough%20Public%20Calendar&src=dWc0Njlib2htcnI4anZyMTZ1YjBrajJyZTgxc3JpdGpAaW1wb3J0LmNhbGVuZGFyLmdvb2dsZS5jb20&src=czZqN3I5ZzNzOWMwNTdsbTByc3U3cXNxam9mbWgzY2dAaW1wb3J0LmNhbGVuZGFyLmdvb2dsZS5jb20&src=b2FsZ2ZkaWd2dWJsOWloZG9wZmQ2ZGljbW5mb3FiMWZAaW1wb3J0LmNhbGVuZGFyLmdvb2dsZS5jb20&color=%2333B679&color=%23D50000&color=%23039BE5" 
            className="calendar-embed" 
            frameBorder="0"
            title="Morrisville Public Calendar Embedded Into Webpage"></iframe>

        </div>
    
</div>
<div className="page-footer bottom-cap-outlines">&nbsp;</div>
<div className="gap-spacer"></div>
</div>

            
            </div>
    )
}
